module.exports = __webpack_public_path__ + "img/profile_grey.d188a540.svg";